const delay = milliseconds => new Promise(resolve => setTimeout(resolve, milliseconds))

export const countExerciseSessions = rows => (
  Array.isArray(rows)
    ? rows.filter(row => row && Array.isArray(row.children) && row.children.length > 0).length
    : 0
)

const fetchExerciseList = async ({
  fetchList,
  minimumSessionCount = null,
  maxAttempts = 6,
  retryDelayMs = 500,
}) => {
  const shouldWaitForSession = Number.isInteger(minimumSessionCount)

  const fetchAttempt = async attemptsRemaining => {
    const response = await fetchList()
    if (
      !shouldWaitForSession
      || countExerciseSessions(response.data) >= minimumSessionCount
      || attemptsRemaining <= 1
    ) return response

    await delay(retryDelayMs)
    return fetchAttempt(attemptsRemaining - 1)
  }

  return fetchAttempt(shouldWaitForSession ? maxAttempts : 1)
}

export default fetchExerciseList
